import React from "react";
//#region redux
import { useDispatch } from "react-redux";
import { timeLogsApproved } from "store/actions/timeLogsActions";
import { salaryDeviationWithBusinessUnitsSubmitted } from "store/actions/salaryDeviationsActions";
//#endregion
//#region types
import { StyleEnums } from "models/enums";
import { TranslationKeys } from "translations";
import { WintSuperkollAPIModel, WintSuperkollAPIModelTimeReporting } from "wint-api-client/dist/types";
import { TimeLogsTodoFooterProps } from "models/propTypes/timeReportingPropTypes";
import { PersonCompanyRelationType } from "models/enums/auth";
//#endregion
//#region components
import { PageFooter } from "components/common";
import { useTimeReportingService } from "serviceHooks";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import { CompanyService } from "services";

const TimeLogsTodoFooter: React.FC<TimeLogsTodoFooterProps> = (props) => {
  const timeReportingService = useTimeReportingService();
  const {
    selectedRows,
    allRows,
    reloadHandler,
    salaryDeviationMonthState,
    disableSuccessMessages,
    onlyWithBusinessUnits,
  } = props;
  const dispatch = useDispatch();

  const onTimeLogsApprove = () => {
    const persons = allRows
      .map((row) => ({ id: row.personId, status: row.columns![0].timeReportStatus, checked: (row as any).selected }))
      .filter((row) => row !== undefined) as WintSuperkollAPIModelTimeReporting.ReportDataEmployee[];
    const reportData: WintSuperkollAPIModelTimeReporting.ReportData = {
      employees: persons,
    };

    return timeReportingService.approveTimeReport(reportData);
  };

  const onApproveSuccess = () => {
    reloadHandler(() =>
      dispatch(onlyWithBusinessUnits ? salaryDeviationWithBusinessUnitsSubmitted(0) : timeLogsApproved(0))
    );
  };

  return (
    <PageFooter
      actions={[
        {
          text: `${LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Approve)}${
            selectedRows.length > 0 ? ` (${selectedRows.length})` : ""
          }`,
          onClick: onTimeLogsApprove,
          type: StyleEnums.DisplayType.Success,
          successMessage: LocalizationHelperInstance.getFormattedMessage(
            TranslationKeys.TimeReporting.SubmitTodoSuccessMessage
          ),
          isDisabled:
            selectedRows.length === 0 &&
            !(
              allRows.every((row) => (row as any).disabled) &&
              CompanyService.hasRelation(PersonCompanyRelationType.SalaryAdmin) &&
              salaryDeviationMonthState === WintSuperkollAPIModel.SalaryDeviationMonthState.Created
            ),
          onActionSuccess: onApproveSuccess,
        },
      ]}
      disableSuccessMessages={disableSuccessMessages}
    />
  );
};

export default TimeLogsTodoFooter;
